export enum SchademeldenState {
  Schademelden = 'ols-vraagboom-active-question',
  Samenvatting = 'ols-vraagboom-summary',
  Afhandeling = 'ols-vraagboom-afhandeling',
  Afronden = 'ols-vraagboom-afronden',
  Startscherm = '',
  Verzekeringkiezer = 'ols-vraagboom-verzekeringkiezer'
}
